import Icon from 'components/shared/Icon'
import { MW_DEAL_COMPARE } from 'constants/controllers'
import { replaceUrl } from 'front-end-core/core/history'
import url from 'front-end-core/core/url'
import { difference } from 'libraries/lodash'
import React from 'react'
import TableCell from 'components/dealwatch/TableCell'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const HeaderCell = ({
  paramName,
  getParam,
  sortBy,
  sortOrder,
  compareParams,
  short
}) => {
  if (paramName === null) return <TableCell />

  const { description } = getParam(paramName)

  return (
    <TableCell
      cxNames='pv6 relative bg-light-turquoise'
    >
      <div className='w-max-content min-w13' data-testid='deal-parameter-description'>{description}</div>
      <div className='absolute top1 right2 flex items-center'>
        <SortCellControl
          {...{ paramName, compareParams, short }}
          sortBy={sortBy}
          sortOrder={sortOrder}
        />
        <RemoveCellControl
          {...{ paramName, sortBy, sortOrder, short, compareParams }}
        />
      </div>
    </TableCell>
  )
}

const SortCellControl = ({ paramName, sortBy, sortOrder, compareParams, short }) => {
  const aol = useSelector(selectAolName)

  const onSort = () => {
    const sort = {
      sortBy:
        paramName === sortBy && sortOrder === 'desc' ? undefined : paramName,
      sortOrder:
        paramName === sortBy && sortOrder === 'desc'
          ? undefined
          : paramName === sortBy && sortOrder === 'asc' ? 'desc' : 'asc'
    }
    replaceUrl(url(MW_DEAL_COMPARE, { aol, short }, { show: compareParams, ...sort }))
  }

  return (
    <div
      className='pointer 0-30 hover-o-100'
      onClick={onSort}
    >
      <Icon
        className='w6'
        name={{
          'icon-sort-variant': sortBy !== paramName,
          'icon-sort-ascending': sortBy === paramName && sortOrder === 'asc',
          'icon-sort-descending': sortBy === paramName && sortOrder === 'desc'
        }}
      />
    </div>
  )
}

const RemoveCellControl = ({ paramName, compareParams, short, sortBy, sortOrder }) => {
  const aol = useSelector(selectAolName)

  const handleOnClick = () => {
    const show = difference(compareParams, [paramName])
    replaceUrl(url(
      MW_DEAL_COMPARE,
      { aol, short },
      {
        show,
        ...(!sortBy && { sortBy }),
        ...(!sortOrder && { sortOrder })
      }
    ))
  }

  return (
    <div
      className='pointer 0-30 hover-o-100'
      onClick={handleOnClick}
      data-testid='remove-column-button'
    >
      <Icon
        className='w6'
        name='icon-close'
      />
    </div>
  )
}

export default HeaderCell
